<template>
  <div class="seller-list">
    <Row>
      <Col :xs="24"
           :sm="24">
      <Form :model="formItem"
            ref="formItem"
            :inline="true"
            action="javascript:void(0)">
        <FormItem>
          <Button @click="addGoodCate"
                  type="success"
                  class="f-r">创建配色</Button>
        </FormItem>
      </Form>
      </Col>
    </Row>
    <Table border
           :columns="list"
           :data="tablelist"
           :loading="dataloading"></Table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page ref="listPage"
              :total="pages.total"
              :current="pages.page"
              :page-size="pages.size"
              show-elevator
              show-total
              @on-change="changePage()"></Page>
      </div>
    </div>
    <Drawer :title="title"
            v-model="showModalStatus"
            width="1000"
            :mask-closable="false"
            :styles="styles">
      <Form :model="seller"
            :label-width="110">
        <FormItem label="选择产品池"
                  label-position="top">
          <Select v-model="seller.pool_id"
                  clearable
                  filterable
                  placeholder="选择产品池">
            <Option v-for="item in pooltablelist"
                    :value="item.id"
                    :key="item.id">{{item.name}}</Option>
          </Select>
        </FormItem>
        <FormItem label="页面背景图">
          <upload-thumb v-model="seller.page_back_thumb"
                        :ref="thumbRefList[0]"
                        :defaultList="thumblist[0]"
                        :autoCropWidth="750"
                        :autoCropHeight="1624"
                        :defaultTip="'图片格式:jpg、jpeg、png、gif,建议图片尺寸:750*1624,大小不超过2M'"></upload-thumb>
        </FormItem>
        <FormItem label="盲盒盒子图">
          <upload-thumb v-model="seller.manghe_thumb"
                        :ref="thumbRefList[1]"
                        :defaultList="thumblist[1]"
                        :autoCropWidth="716"
                        :autoCropHeight="714"
                        :defaultTip="'图片格式:jpg、jpeg、png、gif,建议图片尺寸:716*714,大小不超过2M'"></upload-thumb>
        </FormItem>

        <FormItem label="展开动图">
          <upload-thumb v-model="seller.manghe_gif"
                        :ref="thumbRefList[2]"
                        :defaultList="thumblist[2]"
                        :autoCropWidth="750"
                        :autoCropHeight="750"
                        :defaultTip="'图片格式:jpg、jpeg、png、gif,建议图片尺寸:750*750,大小不超过2M'"></upload-thumb>
        </FormItem>
        <FormItem label="顶部背景">
          <upload-thumb v-model="seller.page_top_thumb"
                        :ref="thumbRefList[3]"
                        :defaultList="thumblist[3]"
                        :autoCropWidth="750"
                        :autoCropHeight="1085"
                        :defaultTip="'图片格式:jpg、jpeg、png、gif,建议图片尺寸:750*1085 ,大小不超过2M'"></upload-thumb>
        </FormItem>
        <FormItem label="商品字体颜色"
                  label-position="top">
          <Input v-model="seller.font_color"
                 style="width:400px"></Input>
        </FormItem>
        <FormItem label="商品背景图"
                  label-position="top">
          <upload-thumb v-model="seller.good_back_thumb"
                        :ref="thumbRefList[4]"
                        :defaultList="thumblist[4]"
                        :autoCropWidth="382"
                        :autoCropHeight="538"
                        :defaultTip="'图片格式:jpg、jpeg、png、gif,建议图片尺寸:382*538,大小不超过2M'"></upload-thumb>
        </FormItem>
        <FormItem label="按钮字体颜色"
                  label-position="top">
          <Input v-model="seller.button_font_color"
                 style="width:400px"></Input>
        </FormItem>
        <FormItem label="主要按钮图"
                  label-position="top">
          <upload-thumb v-model="seller.main_button_thumb"
                        :ref="thumbRefList[5]"
                        :defaultList="thumblist[5]"
                        :autoCropWidth="514"
                        :autoCropHeight="202"
                        :defaultTip="'图片格式:jpg、jpeg、png、gif,建议图片尺寸:514*202,大小不超过2M'"></upload-thumb>
        </FormItem>
        <FormItem label="左侧按钮图"
                  label-position="top">
          <upload-thumb v-model="seller.left_button_thumb"
                        :ref="thumbRefList[6]"
                        :defaultList="thumblist[6]"
                        :autoCropWidth="420"
                        :autoCropHeight="164"
                        :defaultTip="'图片格式:jpg、jpeg、png、gif,建议图片尺寸:420*164,大小不超过2M'"></upload-thumb>
        </FormItem>
        <FormItem label="右侧按钮图"
                  label-position="top">
          <upload-thumb v-model="seller.right_button_thumb"
                        :ref="thumbRefList[7]"
                        :defaultList="thumblist[7]"
                        :autoCropWidth="420"
                        :autoCropHeight="164"
                        :defaultTip="'图片格式:jpg、jpeg、png、gif,建议图片尺寸:420*164,大小不超过2M'"></upload-thumb>
        </FormItem>
        <FormItem label="分享图片"
                  label-position="top">
          <upload-thumb v-model="seller.fangan_share_thumb"
                        :ref="thumbRefList[8]"
                        :defaultList="thumblist[8]"
                        :autoCropWidth="1320"
                        :autoCropHeight="1056"
                        :defaultTip="'图片格式:jpg、jpeg、png、gif,建议图片尺寸:1320*1056,大小不超过2M'"></upload-thumb>
        </FormItem>
        <FormItem label="分享文案"
                  label-position="top">
          <Input type="textarea"
                 v-model="seller.fangan_describe"
                 :rows="3"
                 placeholder="请输入描述" />
        </FormItem>
      </Form>
      <div class="demo-drawer-footer">
        <Button style="margin-right: 8px"
                @click="showModalStatus = false">取消</Button>
        <Button type="primary"
                @click="editgoods()">提交</Button>
      </div>
    </Drawer>
    <!-- 图片查看 start -->
    <viewer :options="viewerOptions"
            :images="viewerImages"
            @inited="inited"
            class="viewerImageWraper"
            ref="viewerImageWraper">
      <template slot-scope="scope">
        <figure class="images">
          <div class="image-wrapper"
               v-for="img in viewerImages"
               :key="img">
            <img class="image"
                 :src="img"
                 :data-source="img"
                 :alt="img"
                 style="display: none;" />
          </div>
        </figure>
      </template>
    </viewer>
    <!-- 图片查看 end -->
  </div>
</template>

<script>
import UploadThumb from "../../common/thumb";
import uploadthumbTwo from "../../common/thumb";
export default {
  name: "seller-list",
  data () {
    return {
      viewerOptions: {
        toolbar: true,
        url: "data-source"
      },
      viewerImages: [],
      pooltablelist: [],
      exportLoading: false,
      //抽屉参数
      value3: false,
      isable: false,
      thumbRefList: [
        "zero",
        "one",
        "two",
        "three",
        "four",
        "five",
        "six",
        "seven",
        "eight"
      ],
      thumblist: [[], [], [], [], [], [], [], [], [], []],
      styles: {
        height: "calc(100% - 55px)",
        overflow: "auto",
        paddingBottom: "53px",
        position: "static"
      },

      seller: {},
      isClear: false,
      loading: true,
      dataloading: true,
      currentId: 0,
      title: "编辑配色",
      pages: {
        page: 1,
        size: 10
      },
      formItem: {
        key: ""
      },
      list: [
        {
          title: "ID",
          key: "id",
          width: 150
        },
        {
          title: "页面背景图",
          key: "page_back_thumb",
          width: 100,
          render: (h, params) => {
            return h("div", [
              h(
                "Avatar",
                {
                  props: {
                    src: params.row.page_back_thumb,
                    shape: "square",
                    size: "large",
                    click: ""
                  },
                  nativeOn: {
                    click: () => {
                      this.showBigImage(params.row.page_back_thumb);
                    }
                  }
                },
                ""
              )
            ]);
          }
        },

        {
          title: "状态",
          key: "status",
          width: 150,
          render: (h, params) => {
            return h("div", [
              h(
                "i-switch",
                {
                  props: {
                    value: !params.row.status // 控制开关的打开或关闭状态，官网文档属性是value
                  },
                  on: {
                    "on-change": value => {
                      this.changeStatus(params.row.id, value);
                    }
                  }
                },
                "开关"
              )
            ]);
          }
        },
        {
          title: "操作",
          key: "action",
          width: 200,
          align: "left",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px"
                  },
                  props: {
                    type: "primary",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.detail(params.row.id);
                    }
                  }
                },
                "编辑"
              ),
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px"
                  },
                  props: {
                    type: "error",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.remove(params.row.id);
                    }
                  }
                },
                "删除"
              )
            ]);
          }
        }
      ],
      tablelist: [],
      showModalStatus: false,
      status: 1
    };
  },
  created: function () {
    this.getTableList();
  },
  components: {
    UploadThumb,
    uploadthumbTwo
  },
  watch: {},
  methods: {
    inited (viewer) {
      this.$viewer = viewer;
    },
    showBigImage (image) {
      console.log("big:", image);
      this.viewerImages = null;
      let imgs = [];
      imgs.push(image);
      this.viewerImages = imgs;
      console.log("this.viewerImages:", this.viewerImages);
      this.$viewer.show();
    },
    getTableList: function () {
      this.renderTable(1);
    },
    //获取产品池
    getPoolList: function (key) {
      var params = {
        page: 1,
        size: 300
      };
      this.$api.productpool.list(params).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.pooltablelist = res.result.list;
        }

      });
      return;
    },
    addGoodCate: function () {
      this.getPoolList();
      this.thumblist = [[], [], [], [], [], [], [], [], []];
      this.currentId = 0;

      this.seller.font_color = "";
      this.seller.button_font_color = "";
      this.seller.fangan_describe = "";
      this.showModalStatus = !this.showModalStatus;
    },
    // 详情
    detail (index) {
      this.getPoolList();
      this.thumblist = [[], [], [], [], [], [], [], [], []];
      this.showModalStatus = !this.showModalStatus;
      this.currentId = index;
      this.$api.manghecolors.manghehomecolordetail({ id: index }).then(res => {
        if (res.code == 200) {
          this.seller = res.result;
          this.pushThumbData([
            this.seller.page_back_thumb,
            this.seller.manghe_thumb,
            this.seller.manghe_gif,
            this.seller.page_top_thumb,
            this.seller.good_back_thumb,
            this.seller.main_button_thumb,
            this.seller.left_button_thumb,
            this.seller.right_button_thumb,
            this.seller.fangan_share_thumb
          ]);
          this.$Message.success(res.msg);
        } else {
          this.$Message.success(res.msg);
        }
      });
    },
    pushThumbData (list) {
      for (var s = 0; s < list.length; s++) {
        if (list[s] != null && list[s] != "") {
          console.log(this.thumblist);
          this.thumblist[s].push({
            name: list[s],
            url: list[s],
            status: "finished"
          });
        }
      }
    },
    // 修改
    editgoods (name) {
      if (this.$refs[this.thumbRefList[0]].uploadList.length > 0) {
        this.seller.page_back_thumb = this.$refs[
          this.thumbRefList[0]
        ].uploadList[0].url;
      }
      if (this.$refs[this.thumbRefList[1]].uploadList.length > 0) {
        this.seller.manghe_thumb = this.$refs[
          this.thumbRefList[1]
        ].uploadList[0].url;
      }
      if (this.$refs[this.thumbRefList[2]].uploadList.length > 0) {
        this.seller.manghe_gif = this.$refs[
          this.thumbRefList[2]
        ].uploadList[0].url;
      }
      if (this.$refs[this.thumbRefList[3]].uploadList.length > 0) {
        this.seller.page_top_thumb = this.$refs[
          this.thumbRefList[3]
        ].uploadList[0].url;
      }
      if (this.$refs[this.thumbRefList[4]].uploadList.length > 0) {
        this.seller.good_back_thumb = this.$refs[
          this.thumbRefList[4]
        ].uploadList[0].url;
      }
      if (this.$refs[this.thumbRefList[5]].uploadList.length > 0) {
        this.seller.main_button_thumb = this.$refs[
          this.thumbRefList[5]
        ].uploadList[0].url;
      }
      if (this.$refs[this.thumbRefList[6]].uploadList.length > 0) {
        this.seller.left_button_thumb = this.$refs[
          this.thumbRefList[6]
        ].uploadList[0].url;
      }
      if (this.$refs[this.thumbRefList[7]].uploadList.length > 0) {
        this.seller.right_button_thumb = this.$refs[
          this.thumbRefList[7]
        ].uploadList[0].url;
      }
      if (this.$refs[this.thumbRefList[8]].uploadList.length > 0) {
        this.seller.fangan_share_thumb = this.$refs[
          this.thumbRefList[8]
        ].uploadList[0].url;
      }
      if (
        this.currentId == null ||
        this.currentId == 0 ||
        this.currentId == ""
      ) {
        this.$api.manghecolors.manghehomecolorcreate(this.seller).then(res => {
          if (res.code == 200) {
            this.showModalStatus = !this.showModalStatus;
            this.getTableList();
          }
        });
      } else {
        this.$api.manghecolors.manghehomecoloredit(this.seller).then(res => {
          if (res.code == 200) {
            this.getTableList();
            this.showModalStatus = !this.showModalStatus;
          }
          this.loading = false;
          this.$nextTick(() => {
            this.loading = true;
          });
        });
      }
    },
    // 删除
    remove: function (id) {
      // 弹出确认框
      this.$Modal.confirm({
        title: "警告",
        content: "<p>此操作不可恢复，三思而后行...</p>",
        onOk: () => {
          this.$api.manghecolors.manghehomecolorremove({ id: id }).then(res => {
            if (res.code == 200) {
              this.$Message.success(res.msg);
              this.getTableList();
            }
          });
        }
      });
    },
    change () { },
    // 翻页
    changePage () {
      this.pages.page = this.$refs["listPage"].currentPage;
      this.renderTable(1);
    },
    // 筛选
    renderTable: function (name) {
      if (name != 1) {
        this.pages.page = 1;
      }
      this.dataloading = true;
      this.tablelist = [];
      var ps = {
        key: this.formItem.key,
        page: this.pages.page,
        size: this.pages.size
      };
      this.$api.manghecolors.manghehomecolorlist(ps).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    },
    // 修改状态
    changeStatus: function (index, value) {
      this.$api.manghecolors
        .manghehomecolorstatus({ id: index, status: value })
        .then(res => {
          if (res.code == 200) {
            this.$Message.success(res.msg);
          } else {
            this.getTableList();
          }
        });
    }
  }
};
</script>

<style>
.demo-drawer-footer {
  width: 100%;
  height: 50px;
  position: absolute;
  bottom: 0;
  left: 0;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  background: #fff;
}
</style>
